import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SchoolHeroPage from './SchoolHeroPage';
import LegacySection from '../../components/LegacySection';
import FounderSection from '../../components/FounderSection';
import "../../components/AchieversSection.css";
import WhyChooseUs from "../../components/WhyChooseUsSection";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolHomePage = ({ schoolData }) => {
  const { school_slug } = useParams();

  // 🔹 FIX: define refs
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);


  const [missionVision, setMissionVision] = useState(null);
  const titleRef = useRef(null);
  const imageRef = useRef(null);
  const [showCta, setShowCta] = useState(false);
  const hasAnimatedRef = useRef(false);

  const [achievers, setAchievers] = useState([]);
  const achieversRef = useRef(null);
  const [achieversVisible, setAchieversVisible] = useState(false);

  const [slidesToShow, setSlidesToShow] = useState(3);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (!about) return;

    const animated = sessionStorage.getItem("aboutAnimated");

    if (animated) {
      titleRef.current?.classList.add("animate-in");
      imageRef.current?.classList.add("slide-in-right");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {

            if (entry.target === titleRef.current) {
              entry.target.classList.add("animate-in");
            }

            if (entry.target === imageRef.current) {
              entry.target.classList.add("slide-in-right");
            }

            sessionStorage.setItem("aboutAnimated", "true");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    if (imageRef.current) observer.observe(imageRef.current);

    return () => observer.disconnect();
  }, [about]);


  /* 🔹 FETCH HOME ABOUT */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}api/home/get_home_about/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1 && res.data.data) {
          setAbout(res.data.data);
        } else {
          setAbout(null);
        }
      })
      .catch(() => setAbout(null));
  }, [school_slug]);

  /* 🔹 FETCH HOME mission vision */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}api/home/get_home_mission_vision/${school_slug}`
      )
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (res.data.data.mission || res.data.data.vision || res.data.data.image)
        ) {
          setMissionVision(res.data.data);
        } else {
          setMissionVision(null);
        }
      })
      .catch(() => setMissionVision(null));
  }, [school_slug]);

  /* ---------------- FETCH ACHIEVERS ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    setLoading(true);

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_achievers/${encodeURIComponent(
          finalSchoolSlug.trim()
        )}`,
        { withCredentials: true }
      )
      .then((res) => {
        console.log("ACHIEVERS API RESPONSE:", res.data);

        if (res.data?.status == 1 && Array.isArray(res.data.data)) {
          setAchievers(res.data.data);
        } else {
          setAchievers([]);
        }
      })
      .catch((err) => {
        console.error("Achiever API error:", err);
        setAchievers([]);
      })
      .finally(() => setLoading(false));
  }, [school_slug]);

  // Acheivers visibility

  useEffect(() => {
    if (!achieversRef.current || achievers.length === 0) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAchieversVisible(true);
          observer.disconnect(); // ✅ trigger once
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(achieversRef.current);

    return () => observer.disconnect();
  }, [achievers]);


  // For acheiver
  const achieverSettings = {
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    swipe: slidesToShow === 1,
    draggable: slidesToShow === 1,
    slidesToShow: slidesToShow,
  };

  useEffect(() => {
    const updateSlides = () => {
      if (window.innerWidth < 768) setSlidesToShow(1);
      else if (window.innerWidth < 1024) setSlidesToShow(2);
      else setSlidesToShow(3);
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);


  return (
    <>
      <SchoolHeroPage />

      {/* 🔹 HOME ABOUT SECTION */}
      {about && about.heading && (
        <section className="about-section">
          <div className="about-container">

            <h2 ref={titleRef} className="about-title">
              {about?.heading}
            </h2>

            <div className="about-content">
              <div className="about-left-section">
                <div className="about-text-wrapper">
                  {about?.about_section_content_1 && (
                    <p className="about-text">{about?.about_section_content_1}</p>
                  )}
                  {about?.about_section_content_2 && (
                    <p className="about-text">{about?.about_section_content_2}</p>
                  )}
                  {about?.about_section_content_3 && (
                    <p className="about-text">{about?.about_section_content_3}</p>
                  )}
                </div>
              </div>

              <div ref={imageRef} className="about-right-section">
                <div className="about-image-container">
                  <img
                    src={
                      about.about_image && about.about_image !== "null"
                        ? `${baseAPIUrl}assets/images/home-page/${about.about_image}`
                        : "/pictures/default-about.jpg"
                    }
                    alt={about.heading}
                    onError={(e) => {
                      e.target.src = "/pictures/default-about.jpg";
                    }}
                  />

                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <LegacySection />
      <FounderSection />
      <WhyChooseUs />

      {/* Acheivers HEADING */}
      <section
        ref={achieversRef}
        className={`achievers-section ${achieversVisible ? "animate-in" : "hidden"
          }`}
      >
        <div className="achievers-container">
          <h2 className="achievers-title">ACHIEVERS</h2>

          {loading ? (
            <p style={{ textAlign: "center" }}>Loading achievers...</p>
          ) : achievers.length > 0 ? (
            <Slider {...achieverSettings} className="achievers-slider achievers-slider-school">
              {achievers.map((item) => (
                <div key={item.id} className="achiever-slide">
                  <div className="achiever-image">
                    <img
                      src={`${baseAPIUrl}assets/images/achievers/${item.achiever_name}`}
                      alt={item.achiever_content}
                      onError={(e) =>
                        (e.target.src = "/pictures/default-user.jpg")
                      }
                    />

                    <div className="achiever-overlay">
                      <p className="achiever-title">
                        {item.achiever_content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <p style={{ textAlign: "center" }}>No achievers available</p>
          )}
        </div>
      </section>

      {/* Application Form Section */}
      <AdmissionApplicationForm/>
    </>
  );
};

export default SchoolHomePage;
